
const UPLOAD_INPROGRESS = "upload-inprogress";

export const VIDEO_STATUS_MAP = {
    PUBLISHED: "Published",
    UNPUBLISHED: "Unpublished",
    DRAFT: "Draft",
    FAILED: "Failed",
    LOADING: UPLOAD_INPROGRESS,
    PROCESSING: "Processing",
}

export const VIDEO_STATUS_OPTIONS = Object.values(VIDEO_STATUS_MAP).map(v => {
    if(v === UPLOAD_INPROGRESS) {
        return { id: UPLOAD_INPROGRESS, name: "Loading" }
    }
    return { id: v.toLowerCase(), name: v }
})
